var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.discipline
    ? _c(
        "div",
        {
          staticClass: "DiscForm",
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "content-box",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [
              _c("div", { staticClass: "title" }, [
                _c("h2", [_vm._v(_vm._s(_vm.$t("AUTHOR.DISCIPLINEEDIT")))])
              ]),
              _c("div", { staticClass: "content" }, [
                _c("form", [
                  _c(
                    "div",
                    { staticClass: "form-block" },
                    [
                      _c("div", { staticClass: "fileInput" }, [
                        _c("span", [_vm._v(_vm._s(_vm.$t("EDITFORM.IMAGE")))]),
                        _c("input", {
                          attrs: { type: "file", name: "imagen" },
                          on: { change: _vm.loadImage }
                        })
                      ]),
                      _vm._l(_vm.fields, function(field, i) {
                        return _c(
                          "div",
                          { key: i },
                          [
                            _c(
                              _vm.componentType(field.type),
                              _vm._b(
                                {
                                  tag: "component",
                                  attrs: {
                                    value: field.value,
                                    options: field.options,
                                    tag: field.name
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "error",
                                        fn: function() {
                                          return [
                                            _c("ValidationError", {
                                              attrs: {
                                                errors: _vm.errors,
                                                name: field.name
                                              }
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: field.value,
                                    callback: function($$v) {
                                      _vm.$set(field, "value", $$v)
                                    },
                                    expression: "field.value"
                                  }
                                },
                                "component",
                                Object.assign({}, field.attributes, {
                                  name: field.name
                                }),
                                false
                              )
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  ),
                  _c("div", { staticClass: "message" })
                ]),
                _vm.formLoaded
                  ? _c(
                      "div",
                      { staticClass: "button-sub" },
                      [
                        _c("BaseButton", { on: { click: _vm.submitData } }, [
                          _vm._v(" " + _vm._s(_vm.$t("BUTTON.SAVE")) + " ")
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }